<div id="user-settings-alerts" class="settings-panel" [class.mobile]="isMobile">
  <div class="head">
    <span class="material-icons go-back" (click)="goBack.emit()"> arrow_back </span>
    <div class="description">
      <div class="title">{{ panelData?.name }}</div>
      <div class="subtitle">{{ panelData?.description }}</div>
    </div>
    <span class="material-icons close" (click)="goBack.emit()"> close </span>
  </div>
  <div class="sub-head" *ngIf="isMobile">
    {{ panelData?.description }}
  </div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="body">
      <div class="alert-loading" *ngIf="isLoading$ | async; else sectionsContent">
        <app-pencil-spinner [diameter]="32" [strokeWidth]="3"></app-pencil-spinner>
      </div>

      <ng-template #sectionsContent>
        <div class="section-group" *ngFor="let section of sections$ | async">
          <h4 class="section-title">{{ section.heading | translate }}</h4>

          <div class="alert-table" role="table" [attr.aria-label]="section.heading | translate">
            <div class="table-header" role="row">
              <div class="type-col" role="columnheader">{{ 'Type' | translate }}</div>
              <div class="priority-col" role="columnheader">{{ 'Priority' | translate }}</div>
            </div>
            <div
              class="table-row"
              *ngFor="let row of section.rows"
              role="row"
              [formGroupName]="row.alertType"
              [class.table-row--disabled]="row.isDisabled"
              [appTooltip]="row.disabledTooltip | translate"
              [appTooltipDisabled]="!row.isDisabled"
              [appTooltipCreateNewLine]="true"
              appTooltipPlacement="bottom-center"
            >
              <div class="type-col" role="cell">
                <mat-checkbox
                  color="primary"
                  formControlName="enabled"
                  [disabled]="row.isDisabled"
                  [attr.aria-label]="row.label | translate"
                ></mat-checkbox>
                <span class="alert-label">{{ row.label | translate }}</span>
              </div>
              <div class="priority-col" role="cell">
                <!-- Safeguarding priority comes from the highest flagged item severity. -->
                <ng-container
                  *ngIf="row.alertType === AlertType.POST_SESSION_SAFEGUARDING; else priorityCell"
                >
                  <span class="alert-rubric">{{ 'Set by rubric' | translate }}</span>
                  <app-pencil-icon
                    class="alert-rubric__info"
                    name="info-outline-dark-gray"
                    [type]="IconTypes.svgIcon"
                    [appTooltip]="
                      'Priority is set automatically from the highest severity issue found in the session.'
                        | translate
                    "
                    [appTooltipPlacement]="'top-end'"
                    [appTooltipArrow]="'bottom-right'"
                    [appTooltipCreateNewLine]="true"
                  ></app-pencil-icon>
                </ng-container>
                <ng-template #priorityCell>
                  <app-alert-priority-dropdown
                    [priority]="form.get([row.alertType, 'defaultPriority'])?.value"
                    (priorityChange)="onPriorityChange(row.alertType, $event)"
                  ></app-alert-priority-dropdown>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <div
      class="foot"
      *ngIf="formState$ | async as formState"
      [class.show]="formState !== FormState.Initial"
    >
      <app-pencil-button
        class="pencil-button primary btn-ok"
        [buttonType]="'submit'"
        [disabled]="formState === FormState.Loading"
      >
        <app-pencil-spinner
          *ngIf="formState === FormState.Loading"
          [diameter]="18"
          [strokeWidth]="3"
        ></app-pencil-spinner>
        <span *ngIf="formState !== FormState.Loading" class="material-icons">check</span>
        <span>{{ 'Update' | translate }}</span>
      </app-pencil-button>
      <app-pencil-button
        class="pencil-button light btn-cancel"
        [buttonType]="'button'"
        (clickEvent)="onCancel()"
        icon="close"
        [iconConfig]="{ type: 'material-icon' }"
        [label]="'Cancel' | translate"
      ></app-pencil-button>
    </div>
  </form>
</div>
